module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [(_vm.group && _vm.group.archived) ? _c('p', [_vm._v("Voor volgend schooljaar kun je je aanmelden bij een nieuwe klas. Voer dan hieronder de uitnodigingscode in die je van jouw docent hebt gekregen.")]) : (_vm.group) ? _c('p', [_vm._v("Je zit nu in klas "), _c('strong', [_vm._v(_vm._s(_vm.group.name))]), _vm._v(".\n    Wil je naar een andere klas verhuizen? Voer dan hieronder de uitnodigingscode van de nieuwe klas in.")]) : _c('p', [_vm._v("Vul hieronder de uitnodigingscode van jouw klas in. Deze code krijg je van je docent.")]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('code')
    }
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Uitnodigingscode")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "name": "code",
      "id": "code",
      "autofocus": !_vm.isTouch
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), (_vm.group) ? _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" je kunt nu nog je huidige werkmap bekijken. Zodra je naar een nieuwe klas verhuist krijg je ook een nieuwe werkmap.")]) : _vm._e(), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.group ? 'Verhuizen' : 'Aanmelden'))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09374a78","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/settings/Group.vue
// module id = ekR1
// module chunks = 0 1